(function () {
    'use strict';

    angular.module('app').factory('notificationsService', NotificationsServiceFactory);

    NotificationsServiceFactory.$inject = ['rx', 'HabilNavigator', 'settingsService', 'enumService'];
    function NotificationsServiceFactory(rx, HabilNavigator, settingsService, enumService) {
        const subject = new rx.Subject();
        let data = {};

        const service = {
            set: function set(d) {
                data = d;
                subject.onNext(d);
            },
            get: function get() {
                return data;
            },
            subscribe: function (o) {
                return subject.subscribe(o);
            },
            Open: open
        };
        return service;

        function open(notification) {
            if (!notification)
                return;
            
            switch (notification.Type) {
                case 'DossierOrganisationComment':
                    HabilNavigator.OpenDossierOrganisation(notification.LinkPublicId);
                    break;
                case 'DossierPersonComment':
                    HabilNavigator.OpenDossierPerson(notification.LinkPublicId);
                    break;
                case 'IvmComment':
                    if (settingsService.appCodeName === enumService.Apps.VO)
                        HabilNavigator.OpenIvmCheck(notification.LinkPublicId);
                    else
                        HabilNavigator.OpenIvmViewOnly(notification.LinkPublicId);
                    break;
                case 'FvmComment':
                    HabilNavigator.OpenFvmViewOnly(notification.LinkPublicId);
                    break;
                case 'ContactPersonRequestComment':
                    HabilNavigator.ContactPerson.OpenViewOnly(notification.LinkPublicId);
                    break;
                case 'PscisRequestComment':
                    HabilNavigator.Pscis.OpenViewOnly(notification.LinkPublicId);
                    break;
            }
        }
    }
})();
